<template>
  <el-dialog
    title="新增任务"
    width="420px"
    :close-on-click-modal="false"
    append-to-body
    v-bind="$attrs"
    v-on="$listeners"
  >
    <el-form
      ref="formRef"
      :model="formData"
      :rules="formRules"
      label-width="120px"
      inline
      size="small"
    >
      <el-form-item label="云桌面镜像ID:" prop="paramArray">
        <el-form-item label="北京" prop="paramArray.cn-beijing">
          <el-input
            v-model="formData.paramArray['cn-beijing']"
            style="width: 240px"
            placeholder="北京-云桌面镜像ID"
          />
        </el-form-item>
        <el-form-item label="深圳" prop="paramArray.cn-shenzhen">
          <el-input
            v-model="formData.paramArray['cn-shenzhen']"
            style="width: 240px"
            placeholder="深圳-云桌面镜像ID"
          />
        </el-form-item>
        <el-form-item label="上海" prop="paramArray.cn-shanghai">
          <el-input
            v-model="formData.paramArray['cn-shanghai']"
            style="width: 240px"
            placeholder="上海-云桌面镜像ID"
          />
        </el-form-item>
        <el-form-item label="杭州" prop="paramArray.cn-hangzhou">
          <el-input
            v-model="formData.paramArray['cn-hangzhou']"
            style="width: 240px"
            placeholder="杭州-云桌面镜像ID"
          />
        </el-form-item>
      </el-form-item>
      <el-form-item label="更新版本:" prop="updateVersion">
        <el-input
          v-model="formData.updateVersion"
          style="width: 240px"
          placeholder="3.2.1"
        />
      </el-form-item>
      <el-form-item label="任务描述:" prop="remark">
        <el-input
          v-model="formData.remark"
          style="width: 240px"
          placeholder="描述此次更新任务的目的"
        />
      </el-form-item>
      <el-form-item label="执行时间:" prop="startDate">
        <el-date-picker
          v-model="formData.startDate"
          style="width: 240px"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
          :picker-options="expireTimeOption"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item class="start-time" label=" " prop="startTime">
        <el-time-select
          v-model="formData.startTime"
          :disabled="!formData.startDate"
          style="width: 240px"
          placeholder="选择时间"
          :picker-options="{
            start: '00:00',
            step: '00:15',
            end: '24:00'
          }"
        >
        </el-time-select>
      </el-form-item>
      <el-row style="margin-top: 20px" type="flex" justify="end">
        <el-button size="small" @click="onCancel">取消</el-button>
        <el-button
          size="small"
          type="primary"
          @click="onSave"
          :loading="saveLoading"
          >确认</el-button
        >
      </el-row>
    </el-form>
  </el-dialog>
</template>

<script>
import moment from "moment";
import { add } from "@/api/rabbit/cloudaliupdatetask";

export default {
  data() {
    return {
      expireTimeOption: {
        disabledDate(time) {
          const today = new Date(); // 获取今天时间
          today.setHours(0, 0, 0, 0); // 将今天的时间设为 0
          time.setHours(0, 0, 0, 0); // 将选中的日期的时间设为 0
          const daysGap = (time.getTime() - today.getTime()) / (24 * 3600 * 1000); // 计算与今天相差的天数
          return daysGap < 0 || daysGap > 5; // 判断是否在今天和后5天之间
        }
      },
      saveLoading: false,
      formData: {
        updateVersion: "",
        remark: "",
        startDate: "",
        startTime: "",
        paramArray: {
          "cn-beijing": "",
          "cn-shenzhen": "",
          "cn-shanghai": "",
          "cn-hangzhou": ""
        }
      },
      formRules: {
        updateVersion: {
          required: true,
          message: "请输入更新版本",
          trigger: "blur"
        },
        "paramArray.cn-beijing": {
          required: true,
          message: "请输入北京-云桌面镜像ID",
          trigger: "blur"
        },
        "paramArray.cn-shenzhen": {
          required: true,
          message: "请输入深圳-云桌面镜像ID",
          trigger: "blur"
        },
        "paramArray.cn-shanghai": {
          required: true,
          message: "请输入上海-云桌面镜像ID",
          trigger: "blur"
        },
        "paramArray.cn-hangzhou": {
          required: true,
          message: "请输入杭州-云桌面镜像ID",
          trigger: "blur"
        },
        startDate: {
          required: true,
          message: "请选择日期",
          trigger: "change"
        },
        startTime: {
          required: true,
          message: "请选择时间",
          trigger: "change"
        }
      }
    };
  },
  watch: {
    "$attrs.visible"(newV) {
      if (!newV) {
        this.saveLoading = false;
        this.$refs.formRef.resetFields();
      }
    }
  },
  methods: {
    // 取消
    onCancel() {
      this.$emit("update:visible", false);
    },
    // 保存表单
    onSave() {
      this.$refs.formRef.validate(valid => {
        if (valid) {
          this.saveLoading = true;
          const {
            updateVersion,
            remark,
            startDate,
            startTime,
            paramArray
          } = this.formData;
          const data = {
            updateVersion,
            remark,
            startTime: `${startDate} ${startTime}:00`,
            paramArray: []
          };
          for (const key in paramArray) {
            data.paramArray.push({
              [key]: paramArray[key]
            });
          }
          data.paramArray = JSON.stringify(data.paramArray);
          add(data)
            .then(() => {
              this.$message.success("新增成功!");
              this.$emit("update:visible", false);
              this.$emit("reload");
            })
            .finally(() => {
              this.saveLoading = false;
            });
        }
      });
    },
    disabledDate(date) {
      return (
        moment(date).isSame(moment(), "day") ||
        moment(date).isBefore(moment(), "day")
      );
    }
  }
};
</script>

<style>
.start-time .el-form-item__label:before {
  display: none;
}
</style>
